import api, { ApiResponse } from "../../api";
import { GetDispatchBoardQueueRequest, GetDispatchBoardQueueResponse } from "./models";

class CityDeliveryDiaptchBoardService {
  private source: any;
  private static instance: CityDeliveryDiaptchBoardService;

  private constructor() { }

  static getInstance(): CityDeliveryDiaptchBoardService {
    if (!CityDeliveryDiaptchBoardService.instance) {
      CityDeliveryDiaptchBoardService.instance = new CityDeliveryDiaptchBoardService();
    }
    return CityDeliveryDiaptchBoardService.instance;
  }

  public getDispatchBoardQueue = async (
    requestData: GetDispatchBoardQueueRequest
  ): Promise<ApiResponse<GetDispatchBoardQueueResponse>> => {
    return await api.get(
      "/disaptch-board/queue",
      { params: requestData }
    );
  };

  
}

export default CityDeliveryDiaptchBoardService;